<template>
  <div id="insider-backtester-insider-restrictions-tab">
    <v-container fluid pa-0>
      <v-row>
        <!-- Optionally Restrict to Specific Insiders -->
        <v-col cols="12" mb-6>
          <helpers-section-sub-header class="mb-6">
            Optionally restrict to specific insiders:
          </helpers-section-sub-header>

          <core-fund-group-manager
            :filer-group="criteria.entry_owners"
            insiders
            optional
            flat
            no-padding
            @update:filer-group="
              newVal => {
                criteria.entry_owners.id = newVal.id
                criteria.entry_owners.filers = newVal.filers
              }
            "
          />
        </v-col>

        <!-- Optionally Exclude Specific Insiders -->
        <v-col cols="12" mb-6>
          <helpers-section-sub-header class="mb-6">
            Optionally exclude specific insiders:
          </helpers-section-sub-header>

          <core-fund-group-manager
            :filer-group="criteria.excluded_owners"
            insiders
            optional
            flat
            no-padding
            @update:filer-group="
              newVal => {
                criteria.excluded_owners.id = newVal.id
                criteria.excluded_owners.filers = newVal.filers
              }
            "
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
// Modules
import { useUserStore, useAppStore, useWwStore } from '@/store'
// Modules
import { mapWritableState } from 'pinia'
export default {
  data() {
    return {
      //{ description: '', id: null, filers: [] };
    }
  },

  computed: {
    ...mapWritableState(useAppStore, ['whaleTraderCriteria', 'signalView', 'exit_time_periods']),
    criteria() {
      return this.whaleTraderCriteria.signals.insider_signal
    },
    appcriteria() {
      return this.whaleTraderCriteria
    },
    enabled() {
      return this.whaleTraderCriteria.signals.insider_signal.enabled
    }
    /* ...mapFields({
      appcriteria: 'app.whaleTraderCriteria',
      criteria: 'app.whaleTraderCriteria.signals.insider_signal',
      enabled: 'app.whaleTraderCriteria.signals.insider_signal.enabled'
    })*/
  },
  created() {
    if (this.criteria.entry_owners instanceof Array) {
      this.criteria.entry_owners = { description: '', id: null, filers: [] }
    }
    if (this.criteria.excluded_owners instanceof Array) {
      this.criteria.excluded_owners = { description: '', id: null, filers: [] }
    }
  }
}
</script>
